import PropTypes from 'prop-types';
import Link from '../../../components/address/Link';
import DetailedTooltipIcon from '../../../components/detailed-tooltip/DetailedTooltipIcon';
import Translation from '../../../lang/Translation';

export default function FieldInfoAndMessages(props) {
  return (
    <>
      {props.toolTip && <DetailedTooltipIcon tooltipID={props.toolTip} label={Translation.getText(props.label)} />}
      {props.link && <Link {...props.link} />}
    </>
  );
}

FieldInfoAndMessages.propTypes = {
  label: PropTypes.string,
  toolTip: PropTypes.string,
  link: PropTypes.object,
};
